import {createContext, useContext, useState, ReactNode} from 'react';
import {ApiService} from '@/services/apiService';

interface APIContextType {
    api: ApiService | null;
    initAPI: (baseURL: string, email: string, password: string) => Promise<void>;
    initAPIFromSession: (baseURL: string) => void;
}

const APIContext = createContext<APIContextType | null>(null);

export function APIProvider({children}: { children: ReactNode }) {
    const [api, setAPI] = useState<ApiService | null>(null);

    const initAPI = async (baseURL: string, email: string, password: string) => {
        const service = new ApiService(baseURL, email, password);
        await service.login();
        setAPI(service);
    };

    const initAPIFromSession = (baseURL: string) => {
        const service = ApiService.fromSession(baseURL);
        setAPI(service);
    };

    return (
        <APIContext.Provider value={{api, initAPI, initAPIFromSession}}>
            {children}
        </APIContext.Provider>
    );
}

export function useAPI(): APIContextType {
    const context: APIContextType = useContext(APIContext);
    if (!context) throw new Error('useAPI must be used within APIProvider');
    return context;
}
